<template>
  <v-app>
    <v-container fluid>
      <v-layout justify-center>
        <v-flex xs12>
          <v-container fluid>
            <v-layout row class="mt-4 mb-3">
              <v-toolbar id="header-toolbar" color="primary" fixed dark app>
                <v-toolbar-title class="ml-0 hidden-sm-and-down">
                  <img :src="computeLogo" height="46" />
                </v-toolbar-title>
                <div>
                  <v-layout row class="layout pl-2 app--page-header">
                    <div class="page-header-left">
                      <h4 class="pr-3 font-weight-medium">Calendario Eventi formativi e Gare di tiro con l'arco CSAIn</h4>
                    </div>
                  </v-layout>
                </div>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-layout>

            <v-layout row wrap justify-center class="mt-4 mb-3">
              <v-flex style="display: contents;">
                <v-icon left class="hidden-sm-and-down mr-3">search</v-icon>

                <v-flex md2 sm3 mt-2 style="margin: 0px 10px;">
                  <v-layout row>
                    <v-spacer></v-spacer>
                    <h5 class="text-uppercase primary--text pa-1 pr-3">Eventi</h5>
                    <v-switch v-model="filtraAttivi" :label="`${filtraAttivi ? 'In Programma' : 'Tutti'}`" class="mt-0"></v-switch>
                    <v-spacer></v-spacer>
                  </v-layout>
                </v-flex>
                <v-flex md1 sm2 style="margin: 0px 10px;">
                  <v-select v-model="filtraAnnoSportivo" :items="anniSportivi" box item-text="Descrizione" label="Anno Sportivo" return-object hide-details></v-select>
                </v-flex>

                <v-flex md2 sm3 style="margin: 0px 10px;">
                  <v-autocomplete
                    v-model="filtraSezioni"
                    :items="sezioni"
                    :return-object="false"
                    item-value="id"
                    item-text="Descrizione"
                    box
                    label="Regione"
                    clearable
                    hide-details
                  ></v-autocomplete>
                </v-flex>
                <v-flex md2 sm3 style="margin: 0px 10px;">
                  <v-autocomplete
                    v-model="filtraTipoEvento"
                    :items="tipiEvento"
                    :return-object="false"
                    item-value="id"
                    item-text="Descrizione"
                    box
                    label="Tipo Evento"
                    clearable
                    hide-details
                  ></v-autocomplete>
                </v-flex>
                <v-flex md2 sm2 style="margin: 0px 10px;">
                  <v-text-field v-model="filtraEventi" box label="Cerca" clearable hide-details></v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
                <v-btn @click="loadEventiViewPublic()" class="text-xs-center" small color="primary white--text"> <v-icon small left color="white">cached</v-icon>Aggiorna </v-btn>
              </v-flex>
            </v-layout>

            <v-data-table
              :headers="headers"
              :hide-headers="isMobile"
              :items="eventiFiltrati"
              :search="filtraEventi"
              :class="{ mobile: isMobile }"
              :rows-per-page-items="[10, 25, 50, { text: 'Tutti', value: -1 }]"
              :pagination.sync="pagination"
              disable-initial-sort
              class="elevation-1 mt-3 noselect"
            >
              <template slot="items" slot-scope="props">
                <tr v-if="!isMobile">
                  <td
                    v-if="props.item.TipoEventoDescrizione === 'Formazione' || props.item.TipoEventoDescrizione === 'Didattico'"
                    :class="{ 'red lighten-5': !props.item.isAttivo }"
                    bold
                    class="text-xs-center"
                  >
                    <v-avatar v-if="props.item.TipoEventoDescrizione === 'Formazione'" size="24" color="purple" small>
                      <span class="white--text xm">F</span>
                    </v-avatar>
                    <v-avatar v-else size="24" color="orange" small>
                      <span class="white--text xm">D</span>
                    </v-avatar>
                  </td>
                  <td v-else :class="{ 'red lighten-5': !props.item.isAttivo }" bold class="text-xs-center">
                    <v-avatar v-if="props.item.isOpen" size="24" color="blue" small>
                      <span class="white--text xm">O</span>
                    </v-avatar>
                    <v-avatar v-else size="24" color="red" small>
                      <span class="white--text xm">U</span>
                    </v-avatar>
                  </td>
                  <td bold>{{ Util.formattaData(props.item.DataEvento) }}</td>
                  <td bold>{{ Util.formattaData(props.item.DataApertura) }}</td>
                  <td bold>{{ Util.formattaData(props.item.DataChiusura) }}</td>
                  <td>{{ props.item.SezioneDescrizione }}</td>
                  <td>{{ props.item.TipoEventoDescrizione }}</td>
                  <td>{{ props.item.AssociazioneDenominazione }}</td>
                  <td>{{ props.item.AssociazioneCodice }}</td>
                  <td>{{ props.item.CittaIndirizzo }}</td>
                  <td>{{ props.item.TitoloEvento }}</td>
                  <td :class="{ 'red lighten-5': !props.item.isAttivo }">
                    <v-tooltip top>
                      <v-btn slot="activator" :disabled="!props.item.Invito" @click="downloadInvito(props.item.id)" small outline icon class="mr-0" color="red">
                        <v-icon small color="red">fa-file</v-icon>
                      </v-btn>
                      <span>Scarica Invito</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn slot="activator" v-if="props.item.Classificati > 0" @click="manageClassifica(props.item.id)" small outline icon class="mr-0" color="blue">
                        <v-icon small color="primary">fa-trophy</v-icon>
                      </v-btn>
                      <span>Scarica la classifica</span>
                    </v-tooltip>
                  </td>
                </tr>

                <tr v-else style="padding-bottom: 10px;">
                  <td>
                    <ul class="flex-content">
                      <li :class="{ 'red lighten-5': !props.item.isAttivo }" data-label="Modalità" style="margin: 5px;" bold class="text-xs-center">
                        <v-avatar v-if="props.item.isOpen" size="24" color="blue" small>
                          <span class="white--text xm">O</span>
                        </v-avatar>
                        <v-avatar v-else size="24" color="red" small>
                          <span class="white--text xm">U</span>
                        </v-avatar>
                      </li>
                      <li style="margin: 5px;" data-label="Data Evento" bold>{{ Util.formattaData(props.item.DataEvento) }}</li>
                      <li style="margin: 5px;" data-label="Data Apertura" bold>{{ Util.formattaData(props.item.DataApertura) }}</li>
                      <li style="margin: 5px;" data-label="Data Chiusura" bold>{{ Util.formattaData(props.item.DataChiusura) }}</li>
                      <li style="margin: 5px;" data-label="Regione">{{ props.item.SezioneDescrizione }}</li>
                      <li style="margin: 5px;" data-label="Tipo">{{ props.item.TipoEventoDescrizione }}</li>
                      <li style="margin: 5px;" data-label="Sodalizio">{{ props.item.AssociazioneDenominazione }}</li>
                      <li style="margin: 5px;" data-label="Codice CSAIN">{{ props.item.AssociazioneCodice }}</li>
                      <li style="margin: 5px;" data-label="Luogo">{{ props.item.CittaIndirizzo }}</li>

                      <li style="margin: 5px;" data-label="Descrizione">{{ props.item.TitoloEvento }}</li>

                      <li :class="{ 'red lighten-5': !props.item.isAttivo }" style="margin: 5px;" data-label="Funzioni">
                        <v-tooltip top>
                          <v-btn slot="activator" :disabled="!props.item.Invito" @click="downloadInvito(props.item.id)" small outline icon class="mr-0" color="red">
                            <v-icon small color="red">fa-file</v-icon>
                          </v-btn>
                          <span>Scarica Invito</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn slot="activator" @click="manageClassifica(props.item.id)" disabled small outline icon class="mr-0" color="blue">
                            <v-icon small color="blue">fa-trophy</v-icon>
                          </v-btn>
                          <span>Scarica la classifica</span>
                        </v-tooltip>
                      </li>
                    </ul>
                  </td>
                </tr>
              </template>

              <template slot="no-results">
                <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun evento</v-alert>
              </template>
              <template slot="no-data">
                <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun evento</v-alert>
              </template>
            </v-data-table>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Util from '@/util';
  import * as moment from 'moment';
  import 'moment/locale/it';
  export default {
    components: {},
    data: () => ({
      isMobile: false,
      Util,
      filtraEventi: '',
      filtraSezioni: '',
      filtraTipoEvento: '',
      filtraAttivi: true,
      filtraAnnoSportivo: '',
      tipoEvtSelezionato: null,
      sezSelezionata: null,
      mese: null,
      headers: [
        { text: 'Modalità', sortable: true, value: 'isOpen', width: '80px', align: 'center' },
        { text: 'Data', sortable: true, value: 'DataEvento' },
        { text: 'Data Apertura', sortable: true, value: 'DataApertura' },
        { text: 'Data Chiusura', sortable: true, value: 'DataChiusura' },
        { text: 'Regione', sortable: true, value: 'SezioneCodice' },
        { text: 'Tipo', sortable: true, value: 'TipoEvento' },
        { text: 'Sodalizio', sortable: true, value: 'AssociazioneDenominazione' },
        { text: 'Codice Csain', sortable: true, value: 'AssociazioneCodice' },
        { text: 'Luogo', sortable: true, value: 'CittaIndirizzo' },
        { text: 'Descrizione', sortable: true, value: 'TitoloEvento' },
        { text: '', sortable: false, value: '', width: '120px', align: 'center' },
      ],
      pagination: {
        rowsPerPage: -1,
      },
    }),

    computed: {
      ...mapGetters('eventiModule', ['getEventiView']),
      ...mapGetters('sharedModule', ['getTipiEvento', 'getAnniSportivi', 'getSezioni']),
      computeLogo() {
        return '/logo.svg';
      },
      calculatedRow() {
        return this.$vuetify.breakpoint.name;
      },
      eventi() {
        return this.getEventiView;
      },
      sezioni() {
        return this.getSezioni;
      },
      tipiEvento() {
        return this.getTipiEvento.filter((p) => {
          return p.Descrizione != 'Didattico';
        });
      },
      anniSportivi() {
        return this.getAnniSportivi;
      },
      eventiFiltrati() {
        return this.filterEventi(this.mese, this.filtraSezioni, this.filtraTipoEvento, this.filtraAnnoSportivo, this.filtraAttivi);
      },
    },
    watch: {
      calculatedRow() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.pagination.rowsPerPage = 10;
            this.isMobile = true;
            break;
          case 'md':
            this.pagination.rowsPerPage = 15;
            this.isMobile = false;
            break;
          case 'lg':
            this.pagination.rowsPerPage = 20;
            this.isMobile = false;
            break;
          case 'xl':
            this.pagination.rowsPerPage = 25;
            this.isMobile = false;
            break;
        }
      },
    },

    created() {
      const vm = this;
      vm.loadTipologie();
      vm.filtraAnnoSportivo =  { 
        id: 183,
        Codice: '20242025',
        Descrizione: '2024/2025',
        Tipo: 'AnnoSportivo',
        Tag: null,};
      this.refreshEvents(this);
      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.isMobile = true;
          break;
        case 'md':
        case 'lg':
        case 'xl':
          this.isMobile = false;
          break;
      }
    },

    methods: {
      ...mapActions('eventiModule', ['loadEventiViewPublic', 'loadInvito']),
      ...mapActions('sharedModule', ['loadTipologie']),
      downloadInvito(idInvito) {
        this.loadInvito(idInvito);
      },

      refreshEvents(cmp) {
        const vm = cmp;
        if (!this.mese) {
          this.mese = new Date();
        }
        this.loadTipologie().then(() => {
          vm.loadEventiViewPublic().then(() => {
            this.mese = new Date();
          });
        });
      },

      manageClassifica(idEvento) {
        // eslint-disable-next-line
        this.$router.push({ name: 'eventi/calendario/classifica', params: { idEvento: idEvento } });
      },

      filterEventi(dataCalendario, sezioneSelezionata, tipoEventoSelezionato, annoSportivo, isAperti) {
        let eventiFiltrati = [];
        this.mese = new Date(dataCalendario);
        eventiFiltrati = this.eventi.filter((e) => {
          return e.isAttivo == true && e.TipoEventoCodice != 'DIDA';
        });

        if (sezioneSelezionata) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.SezioneId == sezioneSelezionata;
          });
        }
        if (tipoEventoSelezionato) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.TipoEventoId == tipoEventoSelezionato;
          });
        }
        if (annoSportivo.id) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.AnnoSportivoId == annoSportivo.id;
          });
        } else {
          eventiFiltrati = this.eventi.filter((e) => {
            const data = new Date(e.DataEvento);
            return data.getFullYear() == this.mese.getFullYear();
          });
        }
        if (isAperti) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            const dataEvento = moment(e.DataEvento);
            return dataEvento.isSameOrAfter(moment(new Date()), 'day');
          });
        }

        Util.sortArrayByKey(eventiFiltrati, 'DataEvento');
        return eventiFiltrati;
      },
    },
  };
</script>
